import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Density = 'dense' | 'comfortable';

interface UiState {
  sidebarCollapsed: boolean;
  density: Density;
  commandPaletteOpen: boolean;
  shortcutsOpen: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (v: boolean) => void;
  setDensity: (d: Density) => void;
  setCommandPaletteOpen: (v: boolean) => void;
  setShortcutsOpen: (v: boolean) => void;
}

// Client-only UI state. Server state stays in TanStack Query (never here).
export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      density: 'dense',
      commandPaletteOpen: false,
      shortcutsOpen: false,
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setSidebarCollapsed: (v) => set({ sidebarCollapsed: v }),
      setDensity: (d) => set({ density: d }),
      setCommandPaletteOpen: (v) => set({ commandPaletteOpen: v }),
      setShortcutsOpen: (v) => set({ shortcutsOpen: v }),
    }),
    {
      name: 'admin-ui',
      partialize: (s) => ({ sidebarCollapsed: s.sidebarCollapsed, density: s.density }),
    },
  ),
);
